
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#19433E",
    },
    secondary: {
      main: "#2196f3",
    },
  },
 
  typography: {
    fontSize: 12, 
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
 
});

export default theme;
